import { render } from "./ListsManageV2.vue?vue&type=template&id=30ee2642&scoped=true"
import script from "./ListsManageV2.vue?vue&type=script&lang=ts"
export * from "./ListsManageV2.vue?vue&type=script&lang=ts"

import "./ListsManageV2.vue?vue&type=style&index=0&id=30ee2642&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30ee2642"

export default script